export enum ERepetitionMode {
  DO_NOT_REPEAT = "DO_NOT_REPEAT",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}
